// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post, put } from '../../../../common/api'
import { ESTIMATE, ADD_ESTIMATE, GET_ESTIMATE, EDIT_ESTIMATE, DELETE_ESTIMATE } from '../../../../common/constant'

export const actionEstimate = createAsyncThunk('appEstimate/actionEstimate', async (params, thunkAPI) => {
    return await post(ESTIMATE, params, thunkAPI)
})

export const actionAddEstimate = createAsyncThunk('appEstimate/actionAddEstimate', async (params, thunkAPI) => {
    return await put(ADD_ESTIMATE, params, thunkAPI)
})

export const actionGetEstimate = createAsyncThunk('appEstimate/actionGetEstimate', async (params, thunkAPI) => {
    return await post(GET_ESTIMATE, params, thunkAPI)
})

export const actionEditEstimate = createAsyncThunk('appEstimate/actionEditEstimate', async (params, thunkAPI) => {
    return await post(EDIT_ESTIMATE, params, thunkAPI)
})

export const actionDeleteEstimate = createAsyncThunk('appEstimate/actionDeleteEstimate', async (params, thunkAPI) => {
    return await post(DELETE_ESTIMATE, params, thunkAPI)
})

export const appEstimateSlice = createSlice({
    name: 'appEstimate',
    initialState: {
        //list
        loading: false,
        estimate: null,

        //add
        loadingAdd: false,
        addEstimate: null,

        //get
        loadingGet: false,
        getEstimate: null,

        //edit
        loadingEdit: false,
        editEstimate: null,

        //delete
        loadingDelete: false,
        deleteEstimate: null

    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetEstimateResponse: (state) => {
            state.estimate = null
        },
        resetAddEstimateResponse: (state) => {
            state.addEstimate = null
        },
        resetGetEstimateResponse: (state) => {
            state.getEstimate = null
        },
        resetEditEstimateResponse: (state) => {
            state.editEstimate = null
        },
        resetDeleteEstimateResponse: (state) => {
            state.deleteEstimate = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionEstimate.pending, (state) => {
                state.loading = true
            })
            .addCase(actionEstimate.fulfilled, (state, action) => {
                state.loading = false
                state.estimate = action.payload
            })
            .addCase(actionEstimate.rejected, (state) => {
                state.loading = false
            })

            //add
            .addCase(actionAddEstimate.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddEstimate.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addEstimate = action.payload
            })
            .addCase(actionAddEstimate.rejected, (state) => {
                state.loadingAdd = false
            })

            //get
            .addCase(actionGetEstimate.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetEstimate.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getEstimate = action.payload
            })
            .addCase(actionGetEstimate.rejected, (state) => {
                state.loadingGet = false
            })

            //edit
            .addCase(actionEditEstimate.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditEstimate.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editEstimate = action.payload
            })
            .addCase(actionEditEstimate.rejected, (state) => {
                state.loadingEdit = false
            })

            //delete
            .addCase(actionDeleteEstimate.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(actionDeleteEstimate.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.deleteEstimate = action.payload
            })
            .addCase(actionDeleteEstimate.rejected, (state) => {
                state.loadingDelete = false
            })
    }
})
export const { resetEstimateResponse, resetAddEstimateResponse, resetGetEstimateResponse, resetEditEstimateResponse, resetDeleteEstimateResponse } = appEstimateSlice.actions

export default appEstimateSlice.reducer